import script from "./PictureUploadForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PictureUploadForm.vue?vue&type=script&setup=true&lang=js"

import "./PictureUploadForm.vue?vue&type=style&index=0&id=04c36b08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04c36b08"]])

export default __exports__